module.exports = __webpack_public_path__ + "static/How-to-Create-Wireframes-in-5-Steps-with-Uizard-c9a8f46317354e4c6bb69f05d6728454.png";